import articlesOutputTab from "../../main-app/handlers/output/output-config/tabs/articles-tab.html";
import {FormatExampleModal} from "../../main-app/modals/format-example-modal/format-example-modal";
import "bootstrap-select";

export default class QuerySchedulingAppOutputConfigHandler {

    modal = $("#outputConfigModal");

    constructor() {
        this.modal.find(".modal-body")
            .append(articlesOutputTab)
            .find(".input-wrapper").remove();
        $('' +
            ' <div class="input-wrapper pane-section">\n' +
            '        <label for="outputFormat" class="inline-label centered-label">Output Format</label>\n' +
            '<select class="selectpicker" id="outputFormat">\n' +
            '  <option>XLSX</option>\n' +
            '  <option>CSV</option>\n' +
            '</select>' +
            '    </div>' +
            '')
            .insertAfter(this.modal.find(".modal-body .pane-section"));
        $('.selectpicker').selectpicker({
            width: '100px',
            size: '2',
            style: 'btn-secondary'
        });

    }

    init() {
        const self = this;
        this.initFormatToggler();
        self.formatExampleModal = new FormatExampleModal();
        self.formatExampleModal.init();
    }

    initFormatToggler() {
        $(".output-property-format-button").on("click", function () {
            const parent = $(this).parent();
            const icon = parent.find('.output-format-arrow');
            if (icon.hasClass("fa-caret-down")) {
                icon.toggleClass("fa-caret-down fa-caret-up");
                parent.find(".output-property-format-wrapper").first().show();
            } else {
                parent.find(".output-property-format-wrapper").first().hide();
                icon.toggleClass("fa-caret-up fa-caret-down");
            }
        });
    }
}